export default __webpack_public_path__ + "static/media/a012-market-2.af9b188c.svg";